import { DegreesToMetersApprox } from 'app/map/geometry/cesium/AsyncPrimitive/utils';
import { calculateSmallestAxisDistance } from 'app/agriculture/FarmMain/MapRenderer/utils/calculateSmallestAxisDistance';
import { PolygonGeometry } from 'app/agriculture/queries/types/geometry/PolygonGeometry';
import { PointGeometry } from 'app/agriculture/queries/types/geometry/PointGeometry';

interface Args {
    geometry: PolygonGeometry;
    pole: PointGeometry;
}

export function generateOverlayRectangleGeometry({
    geometry,
    pole,
}: Args): Cesium.RectangleGeometry {
    const [polygon = []] = geometry.coordinates;
    const smallestAxisDistance = calculateSmallestAxisDistance(polygon, pole.coordinates);
    const [centerLongitude, centerLatitude] = pole.coordinates;

    const rawOffset = smallestAxisDistance * 0.2 * DegreesToMetersApprox; // 20% * degrees to meters conversion

    // the biggest the overlays can get is 100m * 100m
    const offset = Math.min(rawOffset, 50 * DegreesToMetersApprox);

    // longitude gets smaller as we get closer to a pole
    let longitudeScaleFactor = Math.cos(Cesium.Math.toRadians(centerLatitude));
    longitudeScaleFactor = Math.max(0.01, longitudeScaleFactor); // we don't want to divide by 0
    const widthScale = 1 / longitudeScaleFactor;

    return new Cesium.RectangleGeometry({
        rectangle: Cesium.Rectangle.fromDegrees(
            centerLongitude - offset * widthScale,
            centerLatitude - offset,
            centerLongitude + offset * widthScale,
            centerLatitude + offset,
        ),
    });
}
